import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Chewing Gum at at Church',
  date: new Date(2023, 5, 11),
  img: '/img/ball-pit.jpeg',
  tracks: [
    {
      title: 'Take Me Home',
      src: '/songs/2023-06-11/take_me_home.mp3',
    },
    {
      title: 'Lesson to Learn',
      src: '/songs/2023-06-11/lesson_to_learn.mp3',
    },
    {
      title: 'Collective Consciousness',
      src: '/songs/2023-06-11/collective_consciousness.mp3',
    },
    {
      title: 'Fizzy Drink',
      src: '/songs/2023-06-11/fizzy_drink.mp3',
    },
    {
      title: 'Orchestrating or Castrating',
      src: '/songs/2023-06-11/orchestrating_or_castrating.mp3',
    },
    {
      title: 'I got Somethin\' to Say',
      src: '/songs/2023-06-11/i_got_somethin_to_say.mp3',
    },
    {
      title: 'Ball Pit (Chucky E. Cheese)',
      src: '/songs/2023-06-11/ball_pit.mp3',
    },
    {
      title: 'A Spacious Odyssey',
      src: '/songs/2023-06-11/a_spacious_odyssey.mp3',
    },
    {
      title: 'It\'s Not Complicated',
      src: '/songs/2023-06-11/its_not_complicated.mp3',
    },
    {
      title: 'It\'s Complicated',
      src: '/songs/2023-06-11/its_complicated.mp3',
    },
    {
      title: 'ContemPLAYtion',
      src: '/songs/2023-06-11/contemplaytion.mp3',
    },
    {
      title: 'A Lovely Melody',
      src: '/songs/2023-06-11/a_lovely_melody.mp3',
    },
    {
      title: 'Avant-Garden',
      src: '/songs/2023-06-11/avant_garden.mp3',
    },
    {
      title: 'Fly Away With Me',
      src: '/songs/2023-06-11/fly_away_with_me.mp3',
    },
    {
      title: 'Dead Alien in a Jar',
      src: '/songs/2023-06-11/dead_alien_in_a_jar.mp3',
    },
    {
      title: 'Milking the Jar Specimen',
      src: '/songs/2023-06-11/milking_the_jar_specimen.mp3',
    },
    {
      title: 'Chicken Nugget Stanky Cat Butt',
      src: '/songs/2023-06-11/chicken_nugget_stanky_cat_butt.mp3',
    },
    {
      title: 'Feral Cymbal Solos',
      src: '/songs/2023-06-11/feral_cymbal_solos.mp3',
    },
  ]
}
export default album;